<script lang="ts">
    import { _ } from "svelte-i18n"
    import MessageOutlineIcon from "svelte-material-icons/MessageOutline.svelte"
    import CartIcon from "svelte-material-icons/Cart.svelte"
    import AccountCircleIcon from "svelte-material-icons/AccountCircle.svelte"

    import ClipboardTextIcon from "svelte-material-icons/ClipboardText.svelte"
    import MagnifyIcon from "svelte-material-icons/Magnify.svelte"
    import ChevronDownIcon from "svelte-material-icons/ChevronDown.svelte"

    import HeaderSub from "./HeaderSub.svelte"
    import { getCategoryTree } from "../../api"
    import MiniLoader from "../widgets/MiniLoader.svelte"
    import {
        breadcrumbs,
        cart,
        cartOverlay,
        login,
        dealerLoginOverlay,
        location,
        mobileSearchOverlay,
        myOrdersToken,
        preselectedDealerNumber,
    } from "../../store"
    import { hideMegaMenuIdx, menu1MegaMenuIdx } from "../../config"
    import { langField } from "../../i18n"

    let node: CategoryNode
    getCategoryTree().then((n) => {
        node = n
    })

    let menu_open = "none"
    let mobile_menu = false

    const triggerMenu = (which: string, ref: string) => {
        console.log("trigger", which, ref)
        if ((ref == "over" || ref == "out") && typeof window !== "undefined" && window.innerWidth <= 768) {
            return
        }
        // console.log("main " + which, ref)
        menu_open = which ?? "none"

        if (!which && ref != "back") mobile_menu = false
    }

    let cartQty = 0
    $: if ($cart?.length) {
        cartQty = 0

        $cart.forEach((item) => {
            cartQty += item.quantity
        })
    }

    // Scroll Function for Header Bar
    let headerClass = "pin"
    let y = 0
    let lastY = 0
    let lastDirection = "up"

    function changeClass(y: number) {
        let result = headerClass
        const scrolledPxs = lastY - y
        const scrollDirection = scrolledPxs < 0 ? "down" : "up"
        const changedDirection = scrollDirection !== lastDirection
        if (changedDirection) {
            result = scrollDirection === "down" ? "unpin" : "pin"
            lastDirection = scrollDirection
        }
        lastY = y
        return result
    }

    $: headerClass = changeClass(y)
</script>

<header id="header" class="{headerClass}">
    <section>
        {#if !$preselectedDealerNumber}
            <section id="desktop-banner">
                <ul>
                    <li>
                        <span>Hotline:</span>
                        <a href="tel:+4934315889060">03431 588 90 60</a>
                    </li>
                    <li>
                        <span>E-Mail:</span>
                        <a href="mailto:info@renz24.de">info@renz24.de</a>
                    </li>
                </ul>

                <ul>
                    <li><img style="height: 18px;" src="/media/PaypalGroup.svg" alt="PayPal" /></li>
                    <li>
                        <img style="height: 20px;" src="/media/bill.svg" alt="{$_('header.purchase-on-account')}" />{$_(
                            "header.purchase-on-account"
                        )}
                    </li>
                    <li>
                        <img style="height: 20px;" src="/media/Clock.svg" alt="{$_('header.clock-symbol')}" />{$_(
                            "header.short-delivery-time"
                        )}
                    </li>
                    <li>
                        <img
                            style="height: 22px;"
                            src="/media/shield-check.svg"
                            alt="{$_('header.secure-payment-symbol')}"
                        />{$_("header.secure-payment")}
                    </li>
                </ul>
            </section>
        {/if}
        <section id="standard-header">
            <section id="left">
                {#if !$preselectedDealerNumber}
                    <a
                        id="pull"
                        class:active="{mobile_menu}"
                        on:click="{() => (mobile_menu = !mobile_menu)}"
                        role="button"
                    >
                        <span class="pull_button">
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                        <span class="text">{$_("header.menu")}</span>
                    </a>
                    <ul class="mainmenu" class:visible="{mobile_menu}">
                        {#if !node}
                            <MiniLoader />
                        {/if}
                        {#if node}
                            {#each node.childObjects as n, idx}
                                <li
                                    class="menu{menu1MegaMenuIdx.includes(idx) ? '1' : '2'} has_children active"
                                    class:active="{menu_open == 'menu_' + n.id ||
                                        ($breadcrumbs?.length && $breadcrumbs[0].id == n?.id)}"
                                    class:has_children="{!!n.childObjects?.length && !hideMegaMenuIdx.includes(idx)}"
                                    on:mouseenter="{() => {
                                        if (!hideMegaMenuIdx.includes(idx)) {
                                            triggerMenu('menu_' + n.id, 'over')
                                        } else {
                                            menu_open = 'none'
                                        }
                                    }}"
                                >
                                    <a
                                        href="{langField(n.path, '')}"
                                        on:click="{() => {
                                            triggerMenu(undefined, 'click')
                                        }}">{langField(n.name, "")}</a
                                    >
                                    {#if !!n.childObjects?.length && !hideMegaMenuIdx.includes(idx)}
                                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                                        <span
                                            class="navtrigger"
                                            on:click="{() =>
                                                triggerMenu(
                                                    menu_open == 'menu_' + n.id ? 'none' : 'menu_' + n.id,
                                                    'trigger'
                                                )}"
                                        >
                                            <ChevronDownIcon size="22px" />
                                        </span>
                                        {#if menu_open == "menu_" + n.id}
                                            <HeaderSub {triggerMenu} nodes="{n.childObjects}" level="{1}" />
                                        {/if}
                                    {/if}
                                </li>
                            {/each}
                        {/if}

                        <li class="service" class:active="{$location?.path?.startsWith('/service')}">
                            <a
                                href="/service"
                                on:click="{() => {
                                    mobile_menu = false
                                }}"
                                ><MessageOutlineIcon size="24px" /><span style="margin-left: 10px;" class="text"
                                    >{$_("header.service-area")}</span
                                ></a
                            >
                        </li>
                        <li class="service" class:active="{$location?.path?.startsWith('/order')}">
                            <a
                                href="/order{$myOrdersToken ? '/' + $myOrdersToken : ''}"
                                on:click="{() => {
                                    mobile_menu = false
                                }}"
                                ><ClipboardTextIcon size="24px" /><span style="margin-left: 10px;" class="text"
                                    >{$_("header.my-orders")}</span
                                ></a
                            >
                        </li>
                    </ul>
                {/if}
            </section>
            <section id="logo">
                {#if !$preselectedDealerNumber}
                    <a href="/"><img src="media/renz-logo.png" alt="Renz Shop" /></a>
                {:else}
                    <img src="media/renz-logo.png" alt="Renz Shop" />
                {/if}
            </section>
            <section id="right">
                {#if !$preselectedDealerNumber}
                    <ul>
                        <li class="service" class:active="{$location?.path?.startsWith('/service')}">
                            <a href="/service"><span class="text">{$_("header.service-area")}</span></a>
                        </li>
                        <li class="orders" class:active="{$location?.path?.startsWith('/order')}">
                            <a href="/order{$myOrdersToken ? '/' + $myOrdersToken : ''}"
                                ><span class="text">{$_("header.my-orders")}</span></a
                            >
                        </li>
                        <li class="search_mobile">
                            <!-- svelte-ignore a11y-missing-attribute -->
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <a
                                id="searchIconLink"
                                on:click="{() => {
                                    $mobileSearchOverlay = !$mobileSearchOverlay
                                }}"><MagnifyIcon size="24px" /></a
                            >
                        </li>
                        <li class="cartbutton">
                            <!-- svelte-ignore a11y-missing-attribute -->
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <a
                                id="cartIconLink"
                                on:click="{() => {
                                    $cartOverlay = !$cartOverlay
                                }}"
                                ><CartIcon size="24px" />
                                {#if $cart?.length}
                                    <span class="num">{cartQty}</span>
                                {/if}</a
                            >
                        </li>
                        <li class="accountbutton">
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <button
                                class="btn btn-secondary btn-transparent btn-sm"
                                id="dealerLoginIconLink"
                                class:loggedout="{!$login}"
                                on:click="{() => {
                                    $dealerLoginOverlay = !$dealerLoginOverlay
                                }}"
                                ><AccountCircleIcon size="24px" />
                                <span class="text">{$login ? $_("header.logout") : $_("header.login")}</span>
                            </button>
                        </li>
                    </ul>
                {/if}
            </section>
        </section>
    </section>
</header>

<svelte:window bind:scrollY="{y}" />
